import React from 'react';
import { IconProps } from 'common/interfaces';
import useDefaultIconsColor from 'hooks/use-default-icons-color';

export const TrashIcon = ({
  color: colorProp,
  fill: fillProp,
  width = 24,
  height = 24,
  hovered,
  ...restProps
}: IconProps) => {
  const { defaultColor, defaultFill } = useDefaultIconsColor();
  const color = colorProp || defaultColor;
  const fill = fillProp || defaultFill;

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...restProps}
    >
      {hovered && (
        <path
          d='M17.8065 7.93549V19.8387C17.8065 20.4774 17.2839 21 16.6452 21H7.35489C6.71618 21 6.1936 20.4774 6.1936 19.8387V7.93549'
          fill={fill}
        />
      )}
      <path
        d='M8.8064 5.03226V3.87097C8.8064 3.39194 9.19833 3 9.67736 3H14.3225C14.8016 3 15.1935 3.39194 15.1935 3.87097V5.03226'
        fill={hovered ? 'white' : 'none'}
      />
      <path
        d='M8.8064 5.03226V3.87097C8.8064 3.39194 9.19833 3 9.67736 3H14.3225C14.8016 3 15.1935 3.39194 15.1935 3.87097V5.03226'
        stroke={color}
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M12 10.8387V17.8065'
        stroke={color}
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M9.09668 10.8387V17.8065'
        stroke={color}
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M14.9033 10.8387V17.8065'
        stroke={color}
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M14.6129 5.03224H17.8064C18.4451 5.03224 18.9677 5.55482 18.9677 6.19353V7.93547H5.03223V6.19353C5.03223 5.55482 5.55481 5.03224 6.19352 5.03224H12'
        fill={hovered ? 'white' : 'none'}
      />
      <path
        d='M14.6129 5.03224H17.8064C18.4451 5.03224 18.9677 5.55482 18.9677 6.19353V7.93547H5.03223V6.19353C5.03223 5.55482 5.55481 5.03224 6.19352 5.03224H12'
        stroke={color}
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
      <path
        d='M17.8065 9.67742V19.8387C17.8065 20.4774 17.2839 21 16.6452 21H7.35489C6.71618 21 6.1936 20.4774 6.1936 19.8387V7.93549'
        stroke={color}
        stroke-miterlimit='10'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
};
